import type { StoreRepository } from '../StoreRepository';

export class LocalStorageRepository implements StoreRepository {

    private readonly keyServiceUrl;
    private readonly keyToken;
    private readonly keyUserId;

    constructor(params?: {
        serviceUrlKey?: string;
        userIdKey?: string;
        tokenKey?: string;
    }) {
        this.keyServiceUrl = params?.serviceUrlKey || 'serviceUrl';
        this.keyToken = params?.tokenKey || 'token';
        this.keyUserId = params?.userIdKey || 'userId';
    }

    public getServiceUrl(): string | undefined {
        return localStorage.getItem(this.keyServiceUrl) || undefined;
    }

    public getToken(): string | undefined {
        return localStorage.getItem(this.keyToken) || undefined;
    }

    public getUserId(): string | undefined {
        return localStorage.getItem(this.keyUserId) || undefined;
    }

    public setServiceUrl(serviceUrl: string): void {
        localStorage.setItem(this.keyServiceUrl, serviceUrl);
    }

    public setToken(token: string): void {
        localStorage.setItem(this.keyToken, token);
    }

    public setUserId(userId: string): void {
        localStorage.setItem(this.keyUserId, userId);
    }
}
